import React, { useState } from 'react';
import './AddEventPopupModal.css';

interface Track {
  id: string;
  name: string;
}

interface AddEventPopupModalProps {
  date: Date;
  onClose: () => void;
  onSubmit: (data: { date: Date; track_id: string }) => void;
}

let tracks: Track[];
if (process.env.REACT_APP_BUILD_ENV === 'production') {
  tracks = require('./tracks.prod.json');
} else {
  tracks = require('./tracks.staging.json');
}

const AddEventPopupModal: React.FC<AddEventPopupModalProps> = ({ date, onClose, onSubmit }) => {
  const [selectedTrack, setSelectedTrack] = useState<string>(tracks[0]?.id || '');

  const handleSubmit = () => {
    onSubmit({
      date,
      track_id: selectedTrack,
    });
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3>Add Progress for {date.toLocaleDateString()}</h3>
        <label htmlFor="track-select">Select Track:</label>
        <select
          id="track-select"
          value={selectedTrack}
          onChange={(e) => setSelectedTrack(e.target.value)}
        >
          {tracks.map((track) => (
            <option key={track.id} value={track.id}>
              {track.name}
            </option>
          ))}
        </select>
        <button type="button" onClick={handleSubmit}>Submit</button>
        <button type="button" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default AddEventPopupModal;
